import { render, staticRenderFns } from "./formPriceStore.vue?vue&type=template&id=151d2c57&scoped=true"
import script from "./formPriceStore.vue?vue&type=script&lang=js"
export * from "./formPriceStore.vue?vue&type=script&lang=js"
import style0 from "./formPriceStore.vue?vue&type=style&index=0&id=151d2c57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151d2c57",
  null
  
)

export default component.exports